

















import { Vue, Component } from "vue-property-decorator";
import CardTitle from "../../components/CardTitle.vue";
import * as user from "../../_store/user.module";
import * as auth from "../../_store/auth.module";
import * as data from "../../_store/data.module";
import { bus } from "../../main";
import { userUtils } from "../../_utils/userUtils";
import { InstituteInfo } from "../../_models/instituteInfo";
import { UserInfo } from "../../_models/userInfo";
import DetailsDataTable from "../../components/DataTables/DetailsDataTable.vue";
import { EnterpriseInfo } from "../../_models/enterpriseInfo";
import * as temp from "../../_store/temp.module";

@Component({
  components: {
    CardTitle,
    DetailsDataTable
  }
})
export default class GestioneTirEstiviTutorAzienda extends Vue {
  private titleParams: object;
  private dataTableParams: any;
  private createDialogParams: object;
  private reportDataTableParams: any;
  private createReportDialogParams: object;

  private listaPreAssegnazioni: any;
  private listaTutor: any;

  constructor() {
    super();
    this.titleParams = {
      title: "TIROCINI ESTIVI",
      cols: "10",
      sm: "5",
      md: "5",
      lg: "4"
    };
    this.dataTableParams = {
      headers: [
        {
          text: "Allievo",
          value: "allievo"
        },
        {
          text: "Classe",
          value: "classe"
        },
        {
          text: "Dettagli Allievo",
          value: "action",
          sortable: false
        },
        // {
        //   text: "Conferma Abbinamento",
        //   value: "confermaAssegnazione",
        //   sortable: false
        // },
        {
          text: "Dettagli Tirocinio",
          value: "dettagliTirEstivo",
          sortable: false
        },
        // {
        //   text: "Documenti",
        //   value: "dettagliDocTirEstivoAzienda",
        //   sortable: false
        // },
        {
          text: "Report Visita",
          value: "reportVisitaTuorAziendale",
          sortable: false
        },
        {
          text: "Concludi Tirocinio",
          value: "attestatoFinaleTirEstivo",
          sortable: false
        },
        {
          text: "Questionario Soddisfazione",
          value: "questionarioAziendaTirEstivo",
          sortable: false
        },
        {
          text: "Documenti Tirocinio",
          value: "docTirEstivoTutorAzienda",
          sortable: false
        }
      ],
      records: [],
      dialogParams: {
        title: "DETTAGLI ALLIEVO",
        type: "userTab"
      },
      filterType: "listaAbbinamenti",
      tirEstivoDialogParams: {
        title: "DETTAGLI TIROCINIO ESTIVO",
        type: "tirEstivoTab"
      },
      attestatoFinaleDialogParams: {
        title: "ATTESTATO FINALE TIROCINIO ESTIVO",
        type: "attestatoFinale"
      },
      questionarioDialogParams: {
        title: "QUESTIONARIO FINALE",
        type: "questionarioFinale"
      },
      type: "tirocinioEstivo"
    };
    this.reportDataTableParams = {
      headers: [
        {
          text: "Data Visita",
          value: "dataVisita"
        },
        {
          text: "Ora Visita",
          value: "oraVisita"
        },
        {
          text: "Conferma Visita",
          value: "confermaReportTirEstivo"
        }
      ],
      records: [],
      compileDialogParams: {
        title: "REPORT VISITA",
        type: "reportVisita"
      },
      activityType: "tirocinioEstivo"
    };
    this.createReportDialogParams = {
      visible: false,
      type: ""
    };
    this.createDialogParams = {
      visible: false,
      type: ""
    };
    this.listaPreAssegnazioni = [];
    this.listaTutor = [];
  }

  loadAssegnazioni(idAnnoScolastico: number) {
    var enterpriseInfo: EnterpriseInfo = user.readEnterpriseInfo(
      this["$store"]
    );
    var userInfo: UserInfo = user.readUserInfo(this["$store"]);
    var payload = {
      idTutor: userInfo.idUtente,
      idAzienda: enterpriseInfo.idAzienda,
      idAnnoScolastico: idAnnoScolastico
    };
    data
      .dispatchAssociazioniTutorAziendaleTirEstivo(this["$store"], payload)
      .then(result => {
        this.listaPreAssegnazioni = result;
        this.dataTableParams.records = result;
        bus.$emit("dataLoaded");
      })
      .catch(error => {
        if (error.response.status === 403) {
          bus.$emit("errorOperation", error.response.statusText);
          this["$router"].push("/login");
        } else {
          bus.$emit("errorOperation", error.response.statusText);
        }
      });
  }

  created() {
    var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
    var token = localStorage.getItem("userToken");
    var parsedToken: any;
    if (token !== null) {
      parsedToken = userUtils.parseToken(token);
    }
    var payload = {
      idUtente: parsedToken.IdUtente,
      tipoSoggetto: parsedToken.IdTipoSoggetto,
      username: parsedToken.Username
    };
    user
      .dispatchSetUserInfo(this["$store"], payload)
      .then(() => {
        user
          .dispatchSetEnterpriseInfo(this["$store"])
          .then(() => {
            this.loadAssegnazioni(idAnnoScolastico);
            bus.$emit("loadMenu");
          })
          .catch(() => {
            bus.$emit("stopLoading");
            auth.dispatchLogout(this["$store"]);
            user.dispatchClearState(this["$store"]);
            this["$router"].push("/sessionExpired");
          });
      })
      .catch(() => {
        bus.$emit("stopLoading");
        auth.dispatchLogout(this["$store"]);
        user.dispatchClearState(this["$store"]);
        this["$router"].push("/sessionExpired");
      });

    bus.$on("loadAssegnazioni", () => {
      var idAnnoScolastico = temp.readIdAnnoScolastico(this["$store"]);
      this.listaPreAssegnazioni = [];
      this.dataTableParams.records = [];
      this.loadAssegnazioni(idAnnoScolastico);
    });

    bus.$on("changeAnnoScolastico", (payload: any) => {
      this.loadAssegnazioni(payload);
    });
  }
}
